import BaseApi from './base/BaseApi';
import { PutOperation, GetOperation, PostOperation } from './base/operations';

export default class ProjectApi extends BaseApi {
  static entityName = 'projects';

  // fetch item without params
  fetchItem(id, withPreloader = false) {
    const iri = this.getIri(id);
    const operation = new GetOperation(iri);
    return this.execute(operation, withPreloader);
  }

  publish(id, withPreloader = true) {
    const operation = new PutOperation(`/api/projects/${id}/publish`, []);
    return this.execute(operation, withPreloader);
  }

  archive(id, archive, withPreloader = true) {
    const action = archive ? 'archive' : 'unarchive';
    const iri = `/api/projects/${id}/${action}`;
    const operation = new PutOperation(iri, []);
    return this.execute(operation, withPreloader);
  }

  duplicate(id, props = {}, withPreloader = true) {
    const iri = `/api/projects/${id}/duplicate`;
    const operation = new PostOperation(iri, props);
    return this.execute(operation, withPreloader);
  }

  fetchDraft() {
    const operation = new GetOperation('/api/project/draft', []);
    return this.execute(operation, true);
  }
}
